import styled from 'styled-components'

export const Container = styled.div`
    height: 100%;
    width: 100%;
    background-color: #222;
    & > div {
        padding: 20px;
    }
`
